import { useQuery } from '@tanstack/react-query';

import { fetchFreshMessage } from '../api/message';
import { useEnvContext } from '../../modules/EnvProvider';

export default function useFetchHasFreshMessage() {
  const { targetEnv } = useEnvContext();
  const queryResult = useQuery(['fetchFreshMessage'], () => fetchFreshMessage(targetEnv), {
    refetchInterval: 10000,
  });

  return {
    ...queryResult,
    data: queryResult.data?.data,
  };
}
